import React from "react";
import { Fade } from "react-awesome-reveal";

const Agradecimientos = () => {
  return (
    <div id="agradecimientos" className="bg-brown">
      <div className="container">
        <div className="container-text">
          <Fade delay={100} triggerOnce>
            <h5>AGRADECIMIENTOS</h5>
            <p className="texto">
              La Fundación Gustavo Mohme Llona agradece profundamente la
              colaboración que en distintos momentos han ofrecido instituciones
              aliadas. Entre ellas queremos mencionar:
            </p>

            <p>Agencia de la ONU para los Refugiados (ACNUR Perú)</p>
            <p>Amnistía Internacional</p>
            <p>Asociación Nacional de Periodistas (ANP)</p>
            <p>
              Autoridad Nacional de Transparencia y Acceso a la Información
              Pública
            </p>
            <p>Cámara de Comercio de Lima</p>
            <p>Contraloría General de la República</p>
            <p>Fe y Alegría</p>
            <p>Fomento de la Vida (FOVIDA)</p>
            <p>Fundación Friedrich Ebert Stiftung (FES)</p>
            <p>Fundación Konrad Adenauer (KAS Perú)</p>
            <p>Fundación Telefónica</p>
            <p>Grupo La República</p>
            <p>Grupo Propuesta Ciudadana</p>
            <p>Instituto Peruano de Derecho Electoral (IPDE)</p>
            <p>Instituto de Estudios Peruanos (IEP)</p>
            <p>
              Instituto Internacional para la Democracia y Asistencia Electoral
              (IDEA)
            </p>
            <p>Jurado Nacional de Elecciones (JNE)</p>
            <p>Oficina Nacional de Procesos Electorales (ONPE)</p>
            <p>Organismo Supervisor de las Contrataciones del Estado (OSCE)</p>
            <p>Pontificia Universidad Católica del Perú (PUCP)</p>
            <p>Schroth Corporación Papelera</p>
            <p>Sociedad Peruana de Derecho Ambiental (SPDA)</p>
            <p>Universidad Antonio Ruiz de Montoya (UARM)</p>
            <p>Universidad Nacional de Piura (UNP)</p>
            <p>Universidad Nacional de Ucayali (UNU)</p>
            <p>Universidad Nacional del Santa, Áncash (UNS)</p>
            <p>Universidad Nacional San Antonio Abad del Cusco (UNSAAC)</p>
            <p>Universidad Nacional Santiago Antúnez de Mayolo (UNASAM)</p>
            <p>Universidad Peruana de Ciencias Aplicadas (UPC)</p>
          </Fade>
        </div>
      </div>
    </div>
  );
};

export default Agradecimientos;
